import React, { Fragment } from 'react';
import { Button, Modal, Header, Grid } from 'semantic-ui-react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { InventoryBasicSetupFieldEnum as Fields } from 'Common/FieldEnum';
import { Filter, Main } from 'Containers';
import { DirtyWrapper } from 'Components';
import { caseInsensitiveFilter } from 'Common/GridHelper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { HeaderLeftAlign } from 'Common/Constants/table';

import InventoryBasicSetupForm from './InventoryBasicSetupForm';

const InventoryBasicSetupComponent = props => {
  const {
    open,
    size,
    rowData,
    isValid,
    showDeleteModal,
    setUpData,
    addInventoryBasicSetup,
    editInventoryBasicSetup,
    deleteInventoryBasicSetup,
    handleDialog,
    handleSubmit,
    setIsValid,
    close,
    filtered,
    clearFilters,
    loading,
    onFilteredChange,
    humanName,
    isReadOnly,
    isSetUpSubmitting,
  } = props;

  const menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: editInventoryBasicSetup,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: deleteInventoryBasicSetup,
      disabledWhen: x => isReadOnly || x.Status,
    },
  ];

  const columns = [
    {
      Header: 'Id',
      accessor: Fields.Id,
      show: false,
    },
    {
      Header: () => <span className="ml-5">Description</span>,
      accessor: Fields.Description,
      filterable: true,
      resizable: false,
      ...HeaderLeftAlign,
    },
    {
      Header: '',
      id: 'menu',
      width: 120,
      sortable: false,
      resizable: false,
      style: { textAlign: 'center' },
      Cell: gridProps => {
        return GridContextMenu({ gridProps, options: menuOptions });
      },
    },
  ];

  return (
    <Fragment>
      <Filter title={`${humanName} Setup`}>
        <Grid>
          <Grid.Row>
            <Grid.Column floated={'right'} textAlign={'right'}>
              <Button
                content={`Add ${humanName}`}
                onClick={addInventoryBasicSetup}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Filter>
      <Main>
        <Button
          className={'clear-filters-button'}
          content="Clear Filters"
          onClick={clearFilters}
        />
        <ReactTable
          data={_.sortBy(setUpData, [
            Fields.Id,
          ])}
          className={'-striped -highlight grid--fixed-row-height'}
          defaultFilterMethod={caseInsensitiveFilter}
          columns={columns}
          minRows={0}
          pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
          defaultPageSize={10}
          noDataText={loading ? '' : 'No rows found'}
          loadingText={loading ? 'Loading...' : ''}
          loading={loading}
          filtered={filtered}
          onFilteredChange={filtered => onFilteredChange(filtered)}
        />
        <DirtyWrapper closeModalYesCallback={close} isReadOnly={isReadOnly}>
          {showDirtyConfirm => (
            <Modal size={size} open={open} onClose={showDirtyConfirm} closeIcon>
              <Header
                content={
                  rowData.Id === 0
                    ? `Add ${humanName}`
                    : `Edit ${rowData.Description}`
                }
                icon="signup"
              />
              <Modal.Content className="p-t-0">
                <Modal.Description>
                  <InventoryBasicSetupForm
                    setIsValid={setIsValid}
                    ref={instance => {
                      this.form = instance;
                    }}
                    onSubmit={handleSubmit}
                    initialValues={{
                      [Fields.Id]: rowData.Id,
                      [Fields.Description]: rowData.Description,
                    }}
                    humanName={humanName}
                    setUpData={setUpData}
                    isNew={rowData.Id === 0 ? true : false}
                  />
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button
                  inverted
                  color="orange"
                  size="big"
                  loading={loading || isSetUpSubmitting}
                  content="Save"
                  onClick={() => {
                    this.form.submit();
                  }}
                  disabled={!isValid ? true : loading}
                />
              </Modal.Actions>
            </Modal>
          )}
        </DirtyWrapper>
        <YesNoDialog
          showDialog={showDeleteModal}
          title={`Delete ${humanName}`}
          question={` Are you sure you want to delete this ${humanName}: ${
            rowData.Description
          }?`}
          yesCallback={() => {
            handleDialog(true);
          }}
          noCallback={() => {
            handleDialog(false);
          }}
        />
      </Main>
    </Fragment>
  );
};

InventoryBasicSetupComponent.defaultProps = {
  open: false,
  rowData: { Id: 0, Description: '' },
  size: 'mini',
  isValid: false,
  showDeleteModal: false,
  loading: false,
  addInventoryBasicSetup: () => {},
  editInventoryBasicSetup: () => {},
  deleteInventoryBasicSetup: () => {},
  handleDialog: () => {},
  handleSubmit: () => {},
  setIsValid: () => {},
  close: () => {},
  onFilteredChange: () => {},
  clearFilters: () => {},
  sortById: true,
  isReadOnly: true,
  setUpData: [],
  filtered: [],
  humanName: '',
  isSetUpSubmitting: false,
};
InventoryBasicSetupComponent.propTypes = {
  addInventoryBasicSetup: PropTypes.func,
  editInventoryBasicSetup: PropTypes.func,
  deleteInventoryBasicSetup: PropTypes.func,
  handleDialog: PropTypes.func,
  handleSubmit: PropTypes.func,
  setIsValid: PropTypes.func,
  close: PropTypes.func,
  onFilteredChange: PropTypes.func,
  clearFilters: PropTypes.func,
  open: PropTypes.bool,
  isValid: PropTypes.bool,
  loading: PropTypes.bool,
  showDeleteModal: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  size: PropTypes.string,
  rowData: PropTypes.object,
  setUpData: PropTypes.array,
  filtered: PropTypes.array,
  humanName: PropTypes.string,
  isSetUpSubmitting: PropTypes.bool,
};
export default InventoryBasicSetupComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorybasicsetup/components/InventoryBasicSetupComponent.js